import { useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../layouts/layout";
import Search from "../containers/_clients/search";
import ClientsList from "../containers/_clients/clientsList";
import CreateClient from "../containers/_clients/createClient";
import { ConfirmModal } from "../components/confirmModal";
import CUSTOMERS from "../api/services/CUSTOMERS";
import { toast } from "react-toastify";
import styles from "../styles/_screens/clients.module.scss";

const Clients = () => {
  const location = useLocation();
  const isNewFromUrl = new URLSearchParams(location.search).get("new") === "1";

  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(isNewFromUrl);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [success, setSuccess] = useState(null);
  const [dltLoading, setDltLoading] = useState(false);

  const handleDelete = async (userId) => {
    setDltLoading(true);
    try {
      await CUSTOMERS.delete_client({ userId });
      toast.success("הלקוח נמחק בהצלחה");
      setSuccess(true);
      setIsOpenModal(false);
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "שגיאה במחיקת הלקוח");
    }
    setDltLoading(false);
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.main}>
          <header className={styles.pageHeader}>
            <div className={styles.headingBlock}>
              <span className={styles.headingIcon} aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none"><path d="M16 20v-1.5a4.5 4.5 0 0 0-4.5-4.5h-4A4.5 4.5 0 0 0 3 18.5V20M9.5 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM17 8v6M14 11h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
              </span>
              <div>
                <h1>לקוחות</h1>
                <p>ניהול פרטי לקוחות, תורים, חיובים ומסמכים במקום אחד</p>
              </div>
            </div>
            <button type="button" className={styles.addClientBtn} onClick={() => setIsOpen(true)}>
              <svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 4v12M4 10h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg>
              לקוח חדש
            </button>
          </header>
          <Search search={search} setSearch={setSearch} />
          <ClientsList
            search={search}
            setIsOpenModal={setIsOpenModal}
            success={success}
            setSuccess={setSuccess}
          />
        </div>
      </div>

      {isOpen && <CreateClient setIsOpen={setIsOpen} />}

      {isOpenModal && (
        <ConfirmModal
          setIsOpen={setIsOpenModal}
          handleClick={() => handleDelete(isOpenModal)}
          loading={dltLoading}
        />
      )}
    </Layout>
  );
};

export default Clients;
